import { z } from 'zod';
import { createErrorHandler } from './helpers/error-handler';
export const MAX_DOMAIN_LENGTH = 254;
export const domainNameValidator = ({ requiredError, formatError, }) => {
    return z
        .string({
        error: createErrorHandler(requiredError, formatError),
    })
        .superRefine((val, ctx) => {
        const result = z
            .email({ error: formatError })
            .max(MAX_DOMAIN_LENGTH, { message: formatError })
            .safeParse('a@' + val);
        if (result.success) {
            return;
        }
        // This prevents displaying the same format error when
        // email is too long and with invalid format
        ctx.addIssue({ ...result.error.issues[0] });
    });
};
